import { useEffect } from 'react';
import { useParams, useRouteLoaderData } from 'react-router-dom';
import type { PortalNavItem } from '@/types';
import styles from './PharmacyLocatorPage.module.css';

interface EmbeddedPortalPageProps {
  source: 'helpSupport' | 'portalLogin';
}

export function EmbeddedPortalPage({ source }: EmbeddedPortalPageProps) {
  const data = useRouteLoaderData('root') as PortalNavItem | undefined;
  const { code } = useParams();
  const portalLogin = source === 'portalLogin'
    ? data?.portalLogins.find((login) => login.code.toLowerCase() === code?.toLowerCase())
    : undefined;
  const helpSupport = source === 'helpSupport'
    ? data?.quickLinks.find((link) => link.tabId === 'HelpSupport')
    : undefined;
  const url = portalLogin?.url ?? helpSupport?.url;
  const title = portalLogin?.title ?? helpSupport?.label ?? 'Portal';

  useEffect(() => {
    document.title = `DOL ${title}`;
  }, [title]);

  if (!url) {
    return <main className={styles.unavailable}>The requested portal is unavailable.</main>;
  }

  return (
    <main className={styles.page}>
      <iframe
        className={styles.frame}
        src={url}
        title={title}
      />
    </main>
  );
}